/**
 * "Wordloom · a1b2c3d · 24 Sep 2026" — which build is live. Compare the SHA
 * with `git rev-parse --short HEAD` after a deploy (PWA/proxy caches can
 * serve a stale shell). `#version-pill` is a stable hook for deploy probes.
 */
import clsx from 'clsx';
import { BUILD_SHA, BUILD_TIME, formatBuildDate } from '../buildInfo';
import './VersionPill.css';

export function VersionPill({ className }: { className?: string }) {
  const date = formatBuildDate(BUILD_TIME);
  return (
    <span
      id="version-pill"
      className={clsx('version-pill', className)}
      title={`Build ${BUILD_SHA} · ${BUILD_TIME}`}
      data-sha={BUILD_SHA}
    >
      Wordloom · {BUILD_SHA} · {date}
    </span>
  );
}
